import PropTypes from 'prop-types';
import Raven from 'raven-js';
import React, { Component } from 'react';
import { Box, Page } from 'signoxe/components/layout';
import { Button } from 'signoxe/components/widgets';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {error: null};
  }

  static propTypes = {
    children: PropTypes.element,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({error});
    Raven.captureException(error, {extra: errorInfo});
  }

  render() {
    if (this.state.error) {
      const lastEventId = Raven.lastEventId();

      return (
        <Page className="error">
          <p>There has been an error loading this page. Please refresh the page to try again.</p>
          {lastEventId &&
          <Box direction="column" alignItems="flex-start">
            <p>If you would like to send an error report or feedback
               you can click the button below.</p>
            <Button onClick={() => Raven.showReportDialog()}>File Report</Button>
          </Box>}
        </Page>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ErrorBoundary/index.js